import { Link } from 'react-router-dom'
import { ArrowTopRightOnSquareIcon, UserCircleIcon } from '@heroicons/react/24/outline'

import { getRelationId } from './rozmowaDetailsHelpers'

export default function RozmowaOsobaCard({ rozmowa }) {
	const osoba = rozmowa?.id_osoba || rozmowa?.osoba
	const osobaId = getRelationId(osoba)
	const imieINazwisko = osoba?.imie_i_nazwisko || rozmowa?.imie_i_nazwisko || '-'
	const funkcja = osoba?.funkcja || '-'
	const telefon = osoba?.telefon || '-'
	const email = osoba?.email || '-'

	return (
		<div className="mb-5 rounded-md border border-slate-200 bg-white shadow-sm">
			<div className="flex flex-shrink-0 flex-row gap-3 border-b border-slate-300 bg-gray-100 px-6 py-3 sm:items-center sm:justify-between">
				<h2 className="flex items-center gap-2 text-lg font-semibold text-slate-900">
					<UserCircleIcon className="h-5 w-5 text-sky-700" />
					<span>Osoba</span>
				</h2>
				{osobaId ? (
					<Link
						to={`/klienci/osoba/details/${osobaId}`}
						className="inline-flex items-center gap-2 text-sm text-sky-700 hover:text-sky-800">
						<ArrowTopRightOnSquareIcon className="h-5 w-5" />
						<span>Przejdz do szczegolow</span>
					</Link>
				) : null}
			</div>

			<div className="px-6 py-6">
				{!osobaId ? (
					<div className="flex items-center justify-center gap-3 rounded-md bg-slate-50 px-4 py-8 text-sm text-slate-600">
						<UserCircleIcon className="h-5 w-5 text-slate-400" />
						<span>Brak przypisanej osoby.</span>
					</div>
				) : (
					<dl className="grid grid-cols-1 gap-3 text-sm sm:grid-cols-2 lg:grid-cols-4">
						<div>
							<dt className="text-xs font-medium uppercase tracking-wide text-slate-500">Imie i nazwisko</dt>
							<dd className="mt-0.5 text-slate-900">{imieINazwisko}</dd>
						</div>
						<div>
							<dt className="text-xs font-medium uppercase tracking-wide text-slate-500">Funkcja</dt>
							<dd className="mt-0.5 text-slate-900">{funkcja}</dd>
						</div>
						<div>
							<dt className="text-xs font-medium uppercase tracking-wide text-slate-500">Telefon</dt>
							<dd className="mt-0.5 text-slate-900">{telefon}</dd>
						</div>
						<div>
							<dt className="text-xs font-medium uppercase tracking-wide text-slate-500">Email</dt>
							<dd className="mt-0.5 break-all text-slate-900">{email}</dd>
						</div>
					</dl>
				)}
			</div>
		</div>
	)
}
